import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { Input, Label, Utils } from "arv-reactcomponents";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import BodyOverlay from "../../BodyOverlay";
import { scrollTime } from "../../../constants";
import {
  getFilterUrl,
  isDesktop,
  appendCprToUrl,
  isFilterSelected,
  somethingWentWrong,
  getCurrentHref,
} from "../../../utils";

@withRouter
@inject("ProductStore")
@observer
class FilterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSelected:
        props.filterlist.isSelected ||
        isFilterSelected(
          props.filterlist,
          props.mapping,
          props.ProductStore.mobileTempUrlCache.search,
        ),
    };
    this.filterClick = this.filterClick.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      isSelected:
        nextProps.filterlist.isSelected ||
        isFilterSelected(
          nextProps.filterlist,
          nextProps.mapping,
          nextProps.ProductStore.mobileTempUrlCache.search,
        ),
    });
  }
  get showForColor() {
    return (this.props.mapping === "f-co" && "nwc-active") || "nwc-hide";
  }

  filterClick(filterlist) {
    this.props.onFilterSelect();
    this.setState({ isSelected: !this.state.isSelected });
    const { ProductStore, mapping } = this.props;
    const location = isDesktop
      ? this.props.location
      : ProductStore.mobileTempUrlCache;
    let { pathname, search } = location;
    pathname = pathname || this.props.location.pathname;
    search = search || this.props.location.search;
    const pagePath = `${pathname}${search}`;

    ProductStore.setListingPageNo(1);
    const pathWithPageNo = Utils.setUrlParameter(pagePath, "p", 1);

    const initUrl = getFilterUrl(filterlist, mapping, pathWithPageNo);
    const filterUrl = appendCprToUrl(initUrl, ProductStore.ProductData);
    const deliveryPincode =
      ProductStore.omniPincodeCache.delivery_time ||
      ProductStore.omniPincodeCache.nearby_stores;
    const storePincode =
      ProductStore.omniPincodeCache.nearby_stores ||
      ProductStore.omniPincodeCache.delivery_time;
    const { radius } = ProductStore.omniPincodeCache;
    let finalUrl = filterUrl;
    if (deliveryPincode) {
      finalUrl = getFilterUrl({ value: deliveryPincode }, "p-dl", finalUrl);
    }
    if (storePincode) {
      finalUrl = getFilterUrl({ value: storePincode }, "p-st", finalUrl);
    }
    if (radius && storePincode) {
      finalUrl = getFilterUrl({ value: radius }, "r", finalUrl);
    }

    let newUrl = `${pathname}?${finalUrl}`;
    if (isDesktop) {
      BodyOverlay.show();
      ProductStore.getAllProductData(newUrl).then(
        () => {
          Utils.scrollTo(window, 0, 130, scrollTime.fast);
          BodyOverlay.hide();
        },
        () => {
          BodyOverlay.hide();
          somethingWentWrong();
        },
      );
      this.props.history.push(newUrl);
    } else {
      newUrl = `${newUrl}&v=0`;
      ProductStore.getAllProductData(newUrl, "mobileFilters").then(
        () => {},
        () => {
          somethingWentWrong();
        },
      );
      ProductStore.storeTempUrl(pathname, `?${finalUrl}`);
    }
    const filterTitle =
      this.props && (this.props.filterTitle || this.props.name);
    Analytics.trackEvent({
      action: `filter_${filterTitle.toLowerCase()}`,
      category: Event.category.LISTING_PAGE,
      label: getCurrentHref(),
    });
  }
  render() {
    const { filterlist, className } = this.props;
    if (!filterlist || !filterlist.count) return null;

    return (
      <li className="nw-filterlist-eachfilter">
        <Label
          className="nw-filterlist-label"
          htmlFor={`filterlist-each-filter-${filterlist.displayName}`}
        >
          <Input
            id={`filterlist-each-filter-${filterlist.displayName}`}
            type="checkbox"
            value={this.props.index}
            className={`nwc-inp-checkbox-primary nwc-inp-xxs is-covered ${className}`}
            checked={this.state.isSelected}
            name={filterlist.displayName}
            onChange={() => {
              this.filterClick(filterlist);
            }}
          />
          <span
            style={{ backgroundColor: filterlist.colorCode }}
            className={`nw-filterlist-color ${this.showForColor}`}
          />
          <span className={`nw-filterlist-span ${className}`}>
            {filterlist.displayName}
            <span className="nw-filterlist-count">({filterlist.count})</span>
          </span>
        </Label>
        {this.state.isSelected &&
          filterlist.list &&
          filterlist.list.length > 0 && (
            <ul>
              {filterlist.list.map((subfilter, index) => (
                <FilterList
                  filterlist={subfilter}
                  mapping={this.props.mapping}
                  ProductStore={this.props.ProductStore}
                  location={this.props.location}
                  history={this.props.history}
                  className={this.props.className}
                  onFilterSelect={Utils.noop}
                  value={index}
                  key={subfilter.value}
                  type="subFilters"
                />
              ))}
            </ul>
          )}
      </li>
    );
  }
}

FilterList.defaultProps = {
  className: "",
  onFilterSelect: Utils.noop,
  // type: "",
};

FilterList.wrappedComponent.propTypes = {
  // type: PropTypes.string,
  index: PropTypes.number.isRequired,
  filterlist: PropTypes.shape({
    colorCode: PropTypes.string,
    isSelected: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
  mapping: PropTypes.string.isRequired,
  ProductStore: PropTypes.shape({
    setListingPageNo: PropTypes.func.isRequired,
    mobileTempUrlCache: PropTypes.shape().isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  onFilterSelect: PropTypes.func,
  filterTitle: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default FilterList;



// WEBPACK FOOTER //
// ./src/component/ProductFilters/FilterList/index.js